




















































































import i18n from 'vue-i18n';
import EventBus from '@/eventBus';
import CoButton from '@/components/Atoms/co-button/CoButton.vue';
import CoHeadline from '@/components/Atoms/co-headline/CoHeadline.vue';
import CoIcon from '@/components/Atoms/co-icon/CoIcon.vue';
import CoRoundButton from '@/components/Atoms/co-round-button/CoRoundButton.vue';
import CoCard from '@/components/Molecules/co-card/CoCard.vue';
import ListEvents from '@/components/Templates/User/Event/List/ListEvents.vue';
import CoLabel from '@/components/Atoms/co-label/CoLabel.vue';
import CoModal from '@/components/Organisms/co-modal/CoModal.vue';
import CoEditor from '@/components/Molecules/co-editor/CoEditor.vue';
import CoDropdown from '@/components/Molecules/co-dropdown/CoDropdown.vue';
import CoDropdownItem from '@/components/Molecules/co-dropdown-item/CoDropdownItem.vue';
import CoAlert from '@/components/Molecules/co-alert/CoAlert.vue';

export default {
    name: 'MemberEventList',
    i18n: {
        messages: {
            en: {
                shareevents: 'Share public events',
                publiceventlist: 'Public event list',
                embedpubliceventlist: 'Embed event list',
                embedcodeinfo: 'Copy this HTML code and paste it into your website',
            },
            de: {
                shareevents: 'Veranstaltungen teilen',
                publiceventlist: 'Öffentliche Übersicht',
                embedpubliceventlist: 'Übersicht einbetten',
                embedcodeinfo: 'Kopiere diesen HTML-Code und füge ihn in deine Webseite ein',
            },
        },
    },
    components: {
        CoButton,
        CoIcon,
        CoHeadline,
        CoCard,
        CoRoundButton,
        ListEvents,
        CoLabel,
        CoModal,
        CoEditor,
        CoDropdown,
        CoDropdownItem,
        CoAlert,
    },
    data() {
        return {
            isAdmin: this.$store?.state?.me?.Permissions && this.$store.state.me.Permissions.includes('space_admin'),
            embedCode: `<iframe src="${window.location.origin}/embed/events" width="100%" height="100%" frameborder="0"></iframe>`,
        };
    },
    computed: {
        // The events list can stay readable, but creation must disappear when the feature is off.
        isEventsEnabled() {
            return !this.$store?.state?.space?.EventsOff;
        },
        isUserAllowedToCreateEvent() {
            return this.$store.state.permissions && this.$store.state.permissions['events.create'] === true;
        },
    },
    watch: {
        '$store.state.space.EventsOff': {
            handler(isEventsOff) {
                if (isEventsOff) {
                    this.redirectToEventNotFound();
                }
            },
            immediate: true,
        },
    },
    methods: {
        // Redirect disabled event pages to the shared event 404 view.
        redirectToEventNotFound() {
            this.$router.replace('/not-found/event').catch(() => undefined);
        },
        showEmbedModal() {
            this.$refs.embedmodal.show();
        },
        copyValueToClipboard(value) {
            navigator.clipboard.writeText(value);
            EventBus.$emit('INFO', {
                Message: this.$t('messages.copiedtoclipboard'),
                Details: '',
            });
        },
    },
};
